export const environment = {
    production: true,
    serviceUrl: "https://app.nomisign.com/nomiservice/"
};



// WEBPACK FOOTER //
// C:/Users/LenninM/WebstormProjects/NomisignWebApp/src/environments/environment.ts